import { useLang } from '@/i18n';
import { useState } from 'react';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import Link from 'next/link';
import styles from './index.module.scss';
import PartnerModal from '../PartnerModal';

export default function Comp() {
    const { t } = useLang('theProduct.BannerC');
    const [modalVisible, setModalVisible] = useState(false);

    const dataC: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1752811734826/BannerC-pc.jpg',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1752811753599/BannerC-h5.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1752811753599/BannerC-h5.jpg',
    };
    return (
        <div className={styles.comp}>
            <EcoBanner {...dataC} />
            <div className="text-container">
                <h2>{t('title')}</h2>
                <div className="desc">{t(`desc`)}</div>
                <div onClick={() => setModalVisible(true)} className="link">
                    {t(`btn`)}
                </div>
            </div>
            <PartnerModal visible={modalVisible} onClose={() => setModalVisible(false)} />
        </div>
    );
}
